export const SEO_URL_REGEXP = new RegExp('/(snyat|kupit)-(.+)/?$');
export const BASE_FILTERS_URL = '/nd/search/';
